module.exports = "<dt-layout class=\"dt-layout\" layout=\"column\" flex=\"100\"></dt-layout>";